import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[adTimeline]',
})
export class AdTimelineDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
